import { Callout } from "../components/Callout.js";

export const meta = {
  title: "お知らせ・ベル通知",
  updatedAt: "2026-07-23",
};

export function Content() {
  return (
    <>
      <p>
        ナウビレッジから配信される、システムアップデート・障害情報・
        メンテナンス案内などのお知らせを 3 つの場所で受け取れます。
      </p>

      <h2>1. ダッシュボード上部のお知らせバナー</h2>
      <p>
        ダッシュボード（ログイン後トップ）上部に最大 5 件まで表示されます。
      </p>
      <ul>
        <li>
          <strong>重要</strong>マーク付きは赤枠で個別に上部固定
        </li>
        <li>
          通常お知らせは「📣 お知らせ」セクション内にまとめて表示
        </li>
        <li>
          リンク URL が設定されているお知らせは、クリックで詳細ページへ遷移
        </li>
      </ul>

      <h2>2. ヘッダー右上のベルアイコン</h2>
      <p>
        画面右上のベルアイコンに、未読のお知らせ件数に応じて赤い点が表示されます。
        クリックするとドロップダウンでお知らせ一覧が開き、各お知らせの「既読にする」
        ボタンで個別に消せます。
      </p>
      <ul>
        <li>「ベル通知 = ON」と運営側が指定したお知らせのみ表示</li>
        <li>既読状態はユーザーごとに記録</li>
      </ul>

      <h2>3. トースト通知（重要なお知らせのみ）</h2>
      <p>
        「重要」かつ「ベル通知」の両方が ON のお知らせがある時、
        ダッシュボードを開いた直後に画面右上に小さなトーストが表示されます。
        セッションあたり 1 回のみ。閉じるまでフローティング状態。
      </p>

      <h2>利用上限関連の通知</h2>
      <p>
        プラン上限に近づくと自動でメール通知＋ベル通知が送られます。
      </p>
      <ul>
        <li><strong>70%</strong>: 注意喚起</li>
        <li><strong>90%</strong>: 強い注意</li>
        <li><strong>100%</strong>: 上限到達。以降その月は送信できません。プラン変更が必要です</li>
      </ul>

      <Callout type="tip" title="上限通知は請求期間ごとにリセット">
        請求期間が切り替わって送信件数がリセットされると、上限通知のフラグも自動でリセットされます。
        翌月再度上限に近づいた時は新しく通知が届きます。
      </Callout>

      <h2>お知らせの種類</h2>
      <ul>
        <li><strong>アップデート</strong>: 新機能・改善のご案内</li>
        <li><strong>メンテナンス</strong>: 計画的なメンテナンス予告</li>
        <li><strong>障害</strong>: 障害発生・復旧のご報告</li>
        <li><strong>お知らせ</strong>: その他のご案内</li>
      </ul>

      <Callout type="info" title="お知らせの管理">
        お知らせはナウビレッジ運用側が配信しています。お客様側で作成・編集はできません。
        ご質問・ご要望は <a href="/contact">お問い合わせフォーム</a> からお寄せください。
      </Callout>
    </>
  );
}
